/* eslint-disable */
import { StyleSheet } from 'react-native'
import { ApplicationStyles } from '../../Themes/'
import { Fonts } from '../../Themes'
export default StyleSheet.create({
  // ...ApplicationStyles.screen,
  container: {
    flex: 1, flexDirection: 'column'
  },
  noCommentContainerStyle: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  noCommentText: {
    color: Fonts.style.color.light,
    fontSize: Fonts.size.h5,
    marginTop: 30,
    textAlign: 'center',
    lineHeight: 30
  },
  footer: {
    height: 80,
    flexDirection: 'row',
    backgroundColor: '#eee',
  },
  input: {
    paddingHorizontal: 10,
    fontSize: Fonts.size.input,
    flex: 1,
    backgroundColor: 'white',
    marginLeft: 10,
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 3,
  },
  send: {
    alignSelf: 'center',
    padding: 5,
    justifyContent: 'center',
  }
  ,
  noCommentContent: {
    alignItems: 'center',
  },

  mentionView: {
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  deleteButton: {
    backgroundColor: Fonts.style.color.danger,
  },
  deleteText: {
    color: 'white',
  }

})
